import Http from '../clientHttp';
import makeAuthPassport from './makeAuthPassportHttp';

const authPassport = makeAuthPassport(Http);

export default authPassport;
